import React, { Component } from 'react';
import { isFloat } from 'validator';
import numeral from 'numeral';

import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class EditMaterialDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quantity: this.props.material.amount,
            price: this.props.material.price,
            discount: this.props.material.discount ? this.props.material.discount.toString() : '',
            comment: this.props.material.comment || ''
        };
    };

    componentDidMount() {
        this.props.onRef(this);
    }

    calculateTotal = () => {
        return Math.round(
            isFloat(this.state.discount) && this.state.discount !== '' && this.state.discount > 0 
                ? (this.state.price - this.state.price * (this.state.discount / 100)) * this.state.quantity * 100
                : this.state.price * this.state.quantity * 100
        ) / 100;
    }

    validate = () => {
        this.props.onCanSubmit(this.state.product !== '' && this.state.quantity !== '');
    };

    onAddButtonClick = () => {
        // update material
        const updateMovement = {
            material_id: this.props.material.material_id,
            movement_type: 'Project',
            movement_id: this.props.material.movement._id,
            origin_type: this.props.material.movement.origin_type,
            origin_id: this.props.material.movement.origin_id._id,
            destination_type: this.props.material.movement.destination_type,
            destination_id: this.props.material.movement.destination_id._id,
            product: this.props.material.product_id,
            quantity: this.state.quantity,
            price: this.state.price,
            discount: this.state.discount,
            cost: this.calculateTotal(),
            comment: this.state.comment
        };
        this.props.updateMovement(updateMovement);
        // close modal
        this.props.onCloseModal();
    }

    render() {

        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 10 }}>
                    <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Producto</label>
                    <span style={{ lineHeight: '1.6', padding: '6px 0px', fontSize: '14px' }}>
                        {this.props.material.name}
                    </span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 20 }}>
                    <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Comentario</label>
                    <input
                        className="form-control"
                        type="text"
                        value={this.state.comment}
                        onChange={ (event) => {
                            let comment = event.target.value;
                            this.setState({ comment }, this.validate);
                        }}
                    />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 20 }}>
                    <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Cantidad</label>
                    <input
                        className="form-control"
                        type="text"
                        value={this.state.quantity}
                        onChange={ (event) => {
                            let quantity = event.target.value;
                            if (isFloat(quantity) || quantity === '') {
                                this.setState({ quantity }, this.validate );
                            }
                        }}
                    />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 20 }}>
                    <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Precio (€)</label>
                    <input
                        className="form-control"
                        type="text"
                        value={this.state.price}
                        onChange={ (event) => {
                            let price = event.target.value;
                            if (isFloat(price) || price === '') {
                                this.setState({ price }, this.validate );
                            }
                        }}
                    />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 20 }}>
                    <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Descuento %</label>
                    <input
                        className="form-control"
                        type="text"
                        value={this.state.discount}
                        onChange={ (event) => {
                            let discount = event.target.value;
                            if (isFloat(discount) || discount === '') {
                                this.setState({ discount }, this.validate );
                            }
                        }}
                    />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Total (€)</label>
                    <span style={{ lineHeight: '1.6', padding: '6px 0px', fontSize: '14px' }}>
                        {numeral(this.calculateTotal()).format()}
                    </span>
                </div>
            </div>
        );
    }
}

export default EditMaterialDialog;



// WEBPACK FOOTER //
// ./src/components/dialogs/EditMaterialDialog.js